import { Notify } from 'notiflix/build/notiflix-notify-aio';

import {
  setFaqClassic,
  setFaqMonitoringManual,
  setFaqMultilevel,
  setFaqRating,
  setFaqRebate,
  setFaqRebateBrokers,
  setFaqRobot,
  setFaqVpsFree,
  setFaqVpsPaid,
  setFaqWhiteLabel,
} from '@/redux/faq/faqSlice';

import faqService from '@/services/faqService';

const getFaq = tag => async dispatch => {
  try {
    const response = await faqService.getFaq(tag);
    const { data } = response;

    if (tag === 'vps-free') dispatch(setFaqVpsFree(data));
    if (tag === 'vps-paid') dispatch(setFaqVpsPaid(data));
    if (tag === 'monitoring-manual') dispatch(setFaqMonitoringManual(data));
    if (tag === 'rebate') dispatch(setFaqRebate(data));
    if (tag === 'rebate-brokers') dispatch(setFaqRebateBrokers(data));
    if (tag === 'classic') dispatch(setFaqClassic(data));
    if (tag === 'multilevel') dispatch(setFaqMultilevel(data));
    if (tag === 'white-label') dispatch(setFaqWhiteLabel(data));
    if (tag === 'rating') dispatch(setFaqRating(data));
    if (tag === 'robot') dispatch(setFaqRobot(data));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetFaq failure');
  }
};

export default {
  getFaq,
};
